"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppInstallSettingEmpty = isAppInstallSettingEmpty;
exports.isAppInstallSettingRequired = isAppInstallSettingRequired;
exports.listMissingAppInstallSettings = listMissingAppInstallSettings;
const visibility_1 = require("./visibility");
/** Empty at installation; false and zero are deliberately valid selections. */
function isAppInstallSettingEmpty(value) {
    if (value === undefined || value === null)
        return true;
    if (typeof value === 'string')
        return value.trim() === '';
    return Array.isArray(value) && value.length === 0;
}
/** Workspace-local fields must be chosen again, even if authored optional. */
function isAppInstallSettingRequired(slot, stripped) {
    return slot.required === true || stripped.includes(slot.name);
}
/** Uses the install form's actual values, without resolving schema defaults. */
function listMissingAppInstallSettings(input) {
    return input.slots.filter(slot => (0, visibility_1.evaluateVisibility)(slot.visibleIf, input.values) &&
        isAppInstallSettingRequired(slot, input.stripped) &&
        isAppInstallSettingEmpty(input.values[slot.name]));
}
